export default __webpack_public_path__ + "static/media/dark-hero-bg.ea2c44b0.svg";